import React from 'react';
import { useTranslate } from '@bynder/localization';
import { IconDocument, IconFile } from '@bynder/icons';
import { Highlight, SearchItem, SearchResults } from '../../../types';
import { Item } from './Item';
import { calculateHeightStyle } from './calculateHeightStyle';
import { getStaticURL } from '../helpers/getStaticURL';
import { iconSizeExtraLarge, iconSizeMedium } from '../../../helpers/iconSizes';

interface PropsItems {
	searchTerm: string;
	results: SearchResults;
	highLight: Highlight;
	currentActiveSearchItemId?: string;
}

export function GroupStyleGuides({
	searchTerm,
	results,
	highLight,
	currentActiveSearchItemId,
}: PropsItems) {
	const { translate } = useTranslate();
	const { pages } = results;
	const staticURL = getStaticURL();

	const getStrMatch = (page: SearchItem) => {
		if (!highLight || !highLight[page.id]) {
			return '';
		}

		const match = highLight[page.id];
		const regex = /<[^>]+>/gm;

		if (match.description && match.description.length) {
			return match.description[0].replace(regex, '');
		}

		return '';
	};

	return (
		<>
			<li className="">
				<a href="#" className="header no-click" onClick={onDisabledClick}>
					<IconDocument size={iconSizeMedium} /> {translate('styleguide.pagesAllFor')}{' '}
					<b>{searchTerm}</b>
					<span>{pages.total}</span>
				</a>
			</li>
			<div className="spotlight-results" style={calculateHeightStyle(results)}>
				<ul>
					{pages.items.map((page) => {
						const strMatch = getStrMatch(page);

						return (
							<Item
								item={page}
								className="spotlight-collection"
								dataId=""
								dataSrc={`${staticURL}/modules/workflow/includes/img/icons/placeholders/document.png`}
								key={page.id}
								activeSearchResultId={currentActiveSearchItemId}
							>
								<a href={`/Styleguide/?page=${page.id}`}>
									<div className="searchbox-img">
										<IconFile size={iconSizeExtraLarge} />
									</div>
									<p className="searchbox-title">{page.name}</p>

									{strMatch && (
										<p className="searchbox-description">
											<em>{strMatch}</em>
										</p>
									)}
								</a>
							</Item>
						);
					})}
				</ul>
			</div>
		</>
	);
}

const onDisabledClick = (e: React.MouseEvent) => {
	e.stopPropagation();
	e.preventDefault();
};
